import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronGrabberVerticalToward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-grabber-vertical-toward"} maskId="square-filled-radius-0-stroke-1-IconChevronGrabberVerticalToward"><path d="M16.707 18.75L16 19.457L12 15.457L8 19.457L7.29297 18.75L12 14.043L16.707 18.75Z" fill="currentColor"/><path d="M16.707 5.25L12 9.95703L7.29297 5.25L8 4.54297L12 8.54297L16 4.54297L16.707 5.25Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronGrabberVerticalToward;
